<mat-toolbar color='primary'>
    <img src="assets/images/mndnr_small.png" width="50em" alt="Minnesota DNR logo" />
    <h1 style="margin-left:1em;">Lake & Flood Elevations Online</h1>

    <span style="flex: 1 1 auto;"></span>

    <h3>{{fullName}}</h3>
</mat-toolbar>